import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import Default from './Default';
import WebGLSketch from '../_app/cuchillo/3D/WebGLSketch';
import Header from '../layout/Header';
import ScrollIndicator from '../layout/ScrollIndicator';

export default class NoScroll extends Default {
  constructor() {
    super();
  }

  beforeShow() {
    document.body.classList.add('__noScroll');
    super.beforeShow(); // calls Scroll.init() — Lenis starts in running state
    Scroll.stop();      // pause Lenis immediately; InfiniteScroll uses VirtualScroll
  }

  afterShow() {
    this._isActive = true;
    WebGLSketch.enableRaycast();
    Header.enablePointer(); // reactiva el header per si venia desactivat (animació general)
    // Mostra el header com la resta de pàgines. A les pàgines NoScroll el Header.loop() fa
    // return (Scroll parat → !Scroll.isEnabled), així que no es pot re-mostrar sol per scroll:
    // si veníem d'una pàgina amb el header amagat (p.ex. la Home fa scroll-down a la intro →
    // isShow=false, y=-height) quedaria amagat. show() fa el fade d'opacitat; directShow()
    // força y=0 (el show del projecte només anima opacitat, no reseteja la translació).
    Header.show();
    Header.directShow();
    Scroll.show();
    ScrollIndicator.show(); // NoScroll no crida super.afterShow() → cal explícitament
  }

  beforeHide() {
    document.body.classList.remove('__noScroll');
    super.beforeHide();
  }
}

ControllerPage._addPage('no-scroll', NoScroll);
